import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

import type { AgentPresenceColorMode } from '@atlassian/do-not-use-agent-brand/presence-icon-chrome';

export const useAgentAvatarColorMode = (): AgentPresenceColorMode => {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark' ? 'dark' : 'light';
};
